// src/components/elements/FileActionModal.jsx
import React, { useEffect, useRef } from "react";
import "./styles/FileActionModal.css";

const FileActionModal = ({ isOpen, onClose, type, children, title, icon, iconClass }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    if (isOpen) window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fam-overlay"
      ref={overlayRef}
      onClick={(e) => { if (e.target === overlayRef.current) onClose(); }}
      role="dialog"
      aria-modal="true"
    >
      <div className={`fam-modal fam-modal--${type}`}>
        <div className="fam-header">
          <div className="fam-title">
            <span className={`fam-icon fam-icon--${iconClass}`}>{icon}</span>
            <span>{title}</span>
          </div>
          <button className="fam-close" onClick={onClose} aria-label="Close modal">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="fam-body">{children}</div>
      </div>
    </div>
  );
};

export default FileActionModal;
